import React, { useState, useEffect } from "react";
import TopNav from "../layouts/TopNav";
import { FiRefreshCcw } from "react-icons/fi";
import TablePagination from "@mui/material/TablePagination";
import { BsSearch, BsArrowLeft } from "react-icons/bs";
import { toast, ToastContainer } from "react-toastify";
import { useLocation, useNavigate } from "react-router-dom";
import ReLoginModal from "../components/ReLoginModal";
import "../Styles/Modal.css";
import "../Styles/invoiceTable.css";
import "../Styles/invoice.css";
import api from "../util/axios";

type Price = {
  amountIn: string;
  name: string;
  description: string;
  unitOfMeasure: string;
  category: string;
  price: any;
  newSellingPrice: string;
  previousSellingPrice: string;
  details: any;
  role: string;
  updatedAt: string;
  staff: any;
  customer: any;
  customerAccount: any;
  product: any;
  quantity: any;
  amount: any;
};

const Transactions = () => {
  const [getPrice, setGetPrice] = useState<Price[]>([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [reLogin, setReLogin] = useState(false);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [searchField, setSearchField] = useState("businessName");
  const [businessQuery, setBusinessQuery] = useState("");
  const [productQuery, setProductQuery] = useState("");
  const [staffQuery, setStaffQuery] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const pUser = location.state;
  const token = window.localStorage.getItem("token");

  useEffect(() => {
    queryCustomer();
  }, []);

  function queryCustomer() {
    const headers = {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };

    api
      .get("/customer/payments", {
        headers: headers,
      })
      .then((res) => {
        const filteredData = res.data.data.data.filter(
          (data: any) => data?.customer?.businessName === pUser?.businessName
        );
        setGetPrice(filteredData);
      })
      .catch((error) => {
        if (
          error.response.data.message === "jwt expired" ||
          error.response.data.message === "jwt malformed"
        ) {
          toast.error("Session expired, please log in again.");
          setReLogin(true);
        } else {
          setReLogin(false);
        }
        toast.error(error?.response?.data?.message);
      });
  }

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number
  ) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const onRefresh = () => {
    window.location.reload();
  };

  // Filter data based on date range and search fields
  const filteredData = getPrice
    .filter((data) => {
      const dataDate = data.updatedAt.split("T")[0];
      const start = fromDate || "2023-01-01"; // Default start date
      const end = toDate || new Date().toISOString().split("T")[0]; // Current date
      return dataDate >= start && dataDate <= end;
    })
    .filter((data) => {
      if (searchField !== "combined" && !searchQuery) return true;
      if (
        searchField === "combined" &&
        !businessQuery &&
        !productQuery &&
        !staffQuery
      )
        return true;

      const businessName = data?.customer.businessName?.toLowerCase();
      const productName = data?.product?.name?.toLowerCase() || "";
      const staffName = data?.staff?.name?.toLowerCase() || "";

      const businessMatch =
        searchField === "combined"
          ? businessName?.includes(businessQuery.toLowerCase())
          : businessName?.includes(searchQuery.toLowerCase());
      const productMatch =
        searchField === "combined"
          ? productName.includes(productQuery.toLowerCase())
          : productName.includes(searchQuery.toLowerCase());
      const staffMatch =
        searchField === "combined"
          ? staffName.includes(staffQuery.toLowerCase())
          : staffName.includes(searchQuery.toLowerCase());

      switch (searchField) {
        case "businessName":
          return businessMatch;
        case "productName":
          return productMatch;
        case "staffName":
          return staffMatch;
        case "combined":
          return businessMatch && productMatch && staffMatch;
        default:
          return businessMatch;
      }
    })
    .reverse();

  return (
    <div className="board">
      <TopNav title="Transaction History" />
      <ToastContainer />
      {reLogin ? <ReLoginModal /> : null}
      <div className="product">
        <div className="productBtn" style={{ marginBottom: "1px" }}>
          <BsArrowLeft
            style={{ cursor: "pointer" }}
            onClick={() => navigate("/dashboard/customer")}
          />
          <button onClick={onRefresh} className="productBtn1">
            <FiRefreshCcw />
            Refresh
          </button>
        </div>
        <div
          className="method"
          style={{ justifyContent: "flex-end", marginTop: "15px" }}
        >
          <div className="filterBy">
            <strong>Filter by: </strong>
            <span>Start date: </span>
            <input
              type="date"
              name="startDate"
              id=""
              onChange={(e) => setFromDate(e.target.value)}
            />
            <span>End date: </span>
            <input
              type="date"
              name="endDate"
              id=""
              onChange={(e) => setToDate(e.target.value)}
            />
          </div>
          <div className="searchFieldSelect">
            <label htmlFor="filter">Search filter: </label>
            <select
              id="filter"
              value={searchField}
              onChange={(e) => setSearchField(e.target.value)}
            >
              <option value="businessName">Business Name</option>
              <option value="productName">Product</option>
              <option value="staffName">Staff</option>
              <option value="combined">Mixed search</option>
            </select>
          </div>
          {searchField === "combined" ? (
            <div className="combinedSearch">
              <input
                type="text"
                placeholder="Business Name"
                value={businessQuery}
                onChange={(e) => setBusinessQuery(e.target.value)}
              />
              <input
                type="text"
                placeholder="Product"
                value={productQuery}
                onChange={(e) => setProductQuery(e.target.value)}
              />
              <input
                type="text"
                placeholder="Staff"
                value={staffQuery}
                onChange={(e) => setStaffQuery(e.target.value)}
              />
            </div>
          ) : (
            <div className="apInput">
              <input
                type="text"
                value={searchQuery}
                placeholder="Search"
                onChange={(e) => setSearchQuery(e.target.value)}
              />
              <BsSearch className="apIcon" />
            </div>
          )}
        </div>
        <div className="invoiceTable">
          <table className="inTable">
            <thead>
              <tr className="heTable">
                <th className="sn">S/N</th>
                <th>Name</th>
                <th>Details</th>
                <th>Product</th>
                <th>Price</th>
                <th>Prev. quantity</th>
                <th>Quantity</th>
                <th>Amount</th>
                <th>Balance</th>
                <th>Staff</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              {filteredData
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((data, inx) => {
                  const updatedAt = data.updatedAt;
                  const updatedAtDateOnly = updatedAt.split("T")[0];

                  return (
                    <tr key={inx} className="taData">
                      <td className="sn">{page * rowsPerPage + inx + 1}</td>
                      <td>{data?.customer.businessName}</td>
                      <td>{data?.details}</td>
                      <td>{data?.product?.name || ""}</td>
                      <td>{data?.product?.selling || ""}</td>
                      <td>{data?.quantity?.previous}</td>
                      <td>{data?.quantity?.current}</td>
                      <td>
                        ₦{data?.amountIn}
                      </td>
                      <td>₦{data?.product.amount}</td>
                      <td>{data?.staff.name}</td>
                      <td>{updatedAtDateOnly}</td>
                    </tr>
                  );
                })}
            </tbody>
          </table>
        </div>
      </div>
      <TablePagination
        rowsPerPageOptions={[15, 25, 50]}
        component="div"
        count={filteredData.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </div>
  );
};

export default Transactions;